import React, { useContext, useState } from 'react';

import { Grid2 } from '@mui/material';
import { TourContext } from '../../../../../context/tour';

import { DrawerStyled, RotatedImgStyled, VerticalTitleStyled } from './styles';

function ProgressDrawer() {
  const { isProgressOpen, setProgressOpen } = useContext(TourContext);

  const [hover, setHover] = useState(false);

  return (
    <DrawerStyled
      id="tour-drawer"
      container
      direction="column"
      spacing={2}
      alignItems="center"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={() => setProgressOpen(!isProgressOpen)}
    >
      <Grid2 item>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="7"
          viewBox="0 0 12 7"
          style={{
            transform: isProgressOpen ? 'rotate(90deg)' : 'rotate(-90deg)',
          }}
        >
          <path
            d="M13.007,2.858a.825.825,0,0,0-1.153,0L6.438,8.172a.628.628,0,0,0,0,.9l5.416,5.314a.825.825,0,0,0,1.153,0,.788.788,0,0,0,0-1.132L8.289,8.619l4.725-4.636A.787.787,0,0,0,13.007,2.858Z"
            transform="translate(14.622 -6.248) rotate(90)"
            fill={hover ? '#1d6fbb' : '#fff'}
          />
        </svg>
      </Grid2>
      <Grid2 item>
        <VerticalTitleStyled component="p">Tour Rápido</VerticalTitleStyled>
      </Grid2>
      <Grid2 item>
        <RotatedImgStyled src="/Logo_only.svg" alt="" />
      </Grid2>
    </DrawerStyled>
  );
}

export default ProgressDrawer;
